export const SETTINGS = {
  theme: ['light', 'dark'],
  density: ['compact', 'default', 'comfortable'],
  radius: ['none', 'default', 'full'],
  size: ['small', 'medium', 'large', 'touch'],
} as const

export type Setting = keyof typeof SETTINGS
export type SettingMode<S extends Setting> = (typeof SETTINGS)[S][number]

/** The class that puts an element and everything inside it in one mode of a setting (`settings.scss`). */
export function settingClass<S extends Setting>(setting: S, mode: SettingMode<S>): string
export function settingClass<S extends Setting>(setting: S, mode: SettingMode<S> | undefined): string | undefined
export function settingClass<S extends Setting>(setting: S, mode: SettingMode<S> | undefined) {
  return mode === undefined ? undefined : `ynt-${setting}-${mode}`
}
